import { Select } from 'antd';

export const GRADE_OPTIONS = [
  { value: '七年级', value: '七年级', level: '初中' },
  { value: '八年级', value: '八年级', level: '初中' },
  { value: '九年级', value: '九年级', level: '高中' },
  { value: '十年级', value: '十年级', level: '高中' },
  { value: '十一年级', value: '十一年级', level: '高中' },
  { value: '十二年级', value: '十二年级', level: '高中' },
  { value: '高中已毕业', value: '高中已毕业', level: '高中' },
  { value: '大学预科', value: '大学预科', level: '本科' },
  { value: '大一', value: '大一', level: '本科' },
  { value: '大二', value: '大二', level: '本科' },
  { value: '大三', value: '大三', level: '本科' },
  { value: '大四', value: '大四', level: '本科' },
  { value: '大学已毕业', value: '大学已毕业', level: '本科' },
  { value: '研究生预科', value: '研究生预科', level: '研究生' },
  { value: '研究生', value: '研究生', level: '研究生' },
  { value: '研究生已毕业', value: '研究生已毕业', level: '研究生' },
  { value: '未知', value: '未知', level: '未知' },
];

const Grade = ({ disabled, level, ...props }) => {
  let options = GRADE_OPTIONS;
  if (level) {
    options = GRADE_OPTIONS.filter((el) => el.level === level);
  }
  return (
    <Select
      placeholder="年级"
      options={options}
      disabled={disabled}
      showSearch
      filterOption={(input, option) => {
        return option.label.toLowerCase().includes(input.toLowerCase());
      }}
      {...props}
    />
  );
};

export default Grade;
